<h1 mat-dialog-title>Per Diem for the week - Is this correct?</h1>

<mat-dialog-content>
  <div class="mb-1 flex flex-row justify-end">
    <span class="text-sm uppercase">week ending {{ weDate }}</span>
  </div>

  <div class="mb-2 flex items-center justify-between bg-[#ececec] p-2">
    <h3 class="text-xl font-semibold">{{ employeeInfo.display }}</h3>
  </div>
  <div class="grid grid-flow-row gap-10 xl:grid-flow-col">
    <div class="grid w-full min-w-[30rem] grid-flow-row items-center justify-normal gap-10 p-4">
      @for (row of rowsForDisplay; track row) {
        @if (row.mealValue !== '0' || row.hotelValue !== '0') {
          <div class="flex w-full self-start">
            <p class="w-1/2 font-bold">{{ row.label }}</p>
            <p class="w-full font-semibold">Meals (Rate $US)</p>
            <div class="flex w-full justify-end" [class.text-gray-500]="row.mealValue === '0'">
              <p class="font-semibold">$&nbsp;</p>
              <p
                class="w-36 border-b-2 border-solid text-right"
                [ngClass]="row.mealValue === '0' ? 'border-gray-500' : 'border-black font-semibold'"
              >
                {{ row.mealValue | currency: '' : '' }}
              </p>
            </div>
          </div>
        }
      }

      <div class="flex w-full border-t-2 border-solid border-black pt-2">
        <p class="w-1/2 font-bold">MEALS TOTAL</p>
        <div class="flex w-full justify-end">
          <p class="font-semibold">$&nbsp;</p>
          <p class="w-36 text-right font-semibold">{{ totals.meals | currency: '' : '' }}</p>
        </div>
      </div>
    </div>

    <div class="grid w-full min-w-[30rem] grid-flow-row items-center justify-normal gap-10 p-4">
      @for (row of rowsForDisplay; track row) {
        @if (row.mealValue !== '0' || row.hotelValue !== '0') {
          <div class="flex w-full self-start">
            <p class="w-1/2 font-bold">{{ row.label }}</p>
            <p class="w-full font-semibold">Hotel (Rate $US)</p>
            <div class="flex w-full justify-end" [class.text-gray-500]="row.hotelValue === '0'">
              <p class="font-semibold">$&nbsp;</p>
              <p
                class="w-36 border-b-2 border-solid text-right"
                [ngClass]="row.hotelValue === '0' ? 'border-gray-500' : 'border-black font-semibold'"
              >
                {{ row.hotelValue | currency: '' : '' }}
              </p>
            </div>
          </div>
        }
      }

      <div class="flex w-full border-t-2 border-solid border-black pt-2">
        <p class="w-1/2 font-bold">HOTEL TOTAL</p>
        <div class="flex w-full justify-end">
          <p class="font-semibold">$&nbsp;</p>
          <p class="w-36 text-right font-semibold">{{ totals.hotels | currency: '' : '' }}</p>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="confirm()">Pay {{ totals.grandTotal | currency }}</button>
</mat-dialog-actions>
